"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "18.16",
    height: "9.07",
    viewBox: "0 0 18.16 9.07",
    fill: "#dadbd8"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1,3.54H7.9L6.07,1.71A1,1,0,0,1,7.49.29L11,3.83a1,1,0,0,1,0,1.41L7.49,8.78A1,1,0,1,1,6.07,7.36L7.9,5.54H1a1,1,0,0,1,0-2Z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "15.66",
    cy: "4.54",
    r: "2.5"
  }));
};

exports["default"] = _default;